import { ApiProvider } from '@shared/providers/api';

import { BASE_URL } from '@modules/sessions/constants/session';

import { ISessionUpdateAppRepository } from '@modules/sessions/repositories/app/implementations/ISession';

import { TCodeAuthSession } from '@modules/sessions/@types/TSession';

export class SessionUpdateAppRepository implements ISessionUpdateAppRepository {
  private readonly apiProvider = new ApiProvider();

  constructor(
    private readonly FromApi: (_data: TCodeAuthSession) => TCodeAuthSession,
  ) {}

  public async execute(): Promise<TCodeAuthSession> {
    const apiResult = await this.apiProvider.execute<TCodeAuthSession>({
      method: 'patch',
      url: BASE_URL,
    });

    const parsedResult = this.FromApi(apiResult);

    return parsedResult;
  }
}
